module.exports = __webpack_public_path__ + "img/huawei_03.b8b16e59.jpg";